import React from 'react';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';
import { SiteChip } from './SiteChip';
import { BusinessSiteDto } from '../Requests/useGetUsers';

export const SiteColumnHeader = ({ singular = false }: { singular?: boolean }) =>
  <th className="col-2">{singular ? 'Site' : 'Sites'}</th>;

type SiteColumnCellProps =
  | { sites: BusinessSiteDto[] }
  | { siteNames: string[] }
  | { siteName: string | undefined };

const namesOf = (props: SiteColumnCellProps) => {
  if ('siteName' in props) return props.siteName ? [props.siteName] : [];
  if ('siteNames' in props) return props.siteNames;

  return props.sites.map(site => site.name);
};

export const SiteColumnCell = (props: SiteColumnCellProps) => {
  const { numberOfSites } = useSelectedBusiness();
  const siteNames = namesOf(props);
  const atOneSite = 'siteName' in props;
  const assignedToEverySite = !atOneSite && numberOfSites > 0 && siteNames.length === numberOfSites;

  return <td className="align-middle">
    <SiteChip
      siteNames={siteNames}
      totalSiteCount={numberOfSites}
      siteRestricted={!assignedToEverySite} />
  </td>;
};
